var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "소식",
      "sc": "에프원시큐리티의 최신소식입니다",
      "tabActive": "NEWS",
      "icon": "/images/sub/visual/sv4-icon.svg",
      "bg": "/images/sub/visual/sv4.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('router-view', {
    attrs: {
      "name": "board",
      "code": "news",
      "skin": "news",
      "hide-write-button": ""
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }